export default {
  NOT_PUBLISHED: 100,
  PUBLISHED: 200,
  EXPIRED: 300,
  ERROR: 400,
}